import { SetpointProfile } from '../../../../types/generated-types';
import { TemperatureUnit } from '../../../system/models/temperatureUnits';
import { convertLimitTemperature } from './convert-temp-units';

export const convertToPreferredSetpointLimitUnits = (
  setpointProfile: Partial<SetpointProfile>,
  preferredUnits: TemperatureUnit,
) => {
  const formattedLimits: {
    cool: SetpointProfile['cool'];
    heat: SetpointProfile['heat'];
  } = {
    cool: {
      min: convertLimitTemperature(
        setpointProfile.cool?.min,
        preferredUnits,
        'C',
      ),
      max: convertLimitTemperature(
        setpointProfile.cool?.max,
        preferredUnits,
        'C',
      ),
    },
    heat: {
      min: convertLimitTemperature(
        setpointProfile.heat?.min,
        preferredUnits,
        'C',
      ),
      max: convertLimitTemperature(
        setpointProfile.heat?.max,
        preferredUnits,
        'C',
      ),
    },
  };
  return { ...setpointProfile, ...formattedLimits };
};
